import _extends from "@babel/runtime/helpers/esm/extends";
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import Flags from 'country-flag-icons/react/3x2';
import countryList from './CountryList';
import { StyledCountryFlag } from './CountryFlag.style';
const CountryFlag = _ref => {
  let {
    countryName,
    fit = 'medium'
  } = _ref;
  const validCountryName = !!countryName && countryName.split(',').reverse().join(' ').trim().toLowerCase();
  const countryCode = !!validCountryName && (Object.values(countryList).includes(countryName) && countryName || countryList[validCountryName]);
  const Flag = !!countryCode && Flags[countryCode];
  return Flag ? _jsx(StyledCountryFlag, _extends({
    fit: fit
  }, {
    children: _jsx(Flag, {})
  })) : _jsx(_Fragment, {});
};
export default CountryFlag;